<template>
  <div>
    <el-dropdown @command="command">
      <span class="el-dropdown-link">
        {{(wWidth > 976 ? langs : langXs).filter(item => item.code === locale)[0].name}}
        <i class="el-icon-caret-bottom el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="item in wWidth > 976 ? langs : langXs"
                          :key="item.code"
                          :command="item.code"
                          :class="locale == item.code?'lan_menu_hover':''">{{item.name}}</el-dropdown-item>
        <el-dropdown-item v-for="(item,index) in sound"
                          :key="item.code"
                          :command="item.code"
                          :divided="index == 0"
                          :class="soundLocale == item.code ? 'lan_menu_hover':''">
          <span>{{item.name}}</span>
          <img v-if="soundLocale == item.code"
               src="../assets/web/AuditionWhite.png"
               class="sound_icon" />
          <img v-else
               src="../assets/web/Audition.png"
               class="sound_icon" />
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import UserCourseAPI from "../api/UserCourseAPI";
export default {
  data () {
    return {
      langs: [
        { name: "中文繁體", code: "ZH_TW" },
        { name: "中文简体", code: "ZH_CN" },
        { name: "Português", code: "PT" },
        { name: "English", code: "EN" }
      ],
      langXs: [
        { name: "繁", code: "ZH_TW" },
        { name: "简", code: "ZH_CN" },
        { name: "PT", code: "PT" },
        { name: "EN", code: "EN" }
      ],
      sound: [
        { name: "粵語", code: "TW", id: "ZH_TW" },
        { name: "普通話", code: "CN", id: "ZH_CN" },
        { name: "Português", code: "P", id: "PT" },
        { name: "English", code: "E", id: "EN" },
      ],
      soundLocale: "TW",
    };
  },
  watch: {},
  computed: {
    wWidth () {
      return this.$store.state.wWidth;
    },
    locale () {
      return this.$i18n.locale;
    },
  },
  methods: {
    command (item) {
      console.log(item);
      if (item == "TW" || item == "CN" || item == "E" || item == "P") {
        this.soundLocale = item;
        localStorage.setItem("sound", item);
        location.reload();
      } else {
        this.$i18n.locale = item;
        localStorage.setItem("lan", item);
        if(item == 'EN'){
          localStorage.setItem("sound", 'E');
        }else if(item == 'ZH_CN'){
          localStorage.setItem("sound", 'CN');
        }else if(item == 'PT'){
          localStorage.setItem("sound", 'P');
        }else{
          localStorage.setItem("sound", 'TW');
        }
        this.$router.push({
          path: this.$route.path,
          query: { ...this.$route.query, lang: this.$i18n.locale }
        });
        location.reload();
        this.$emit("command");
      }
    },
    setLang(){
      if(this.$route.path === '/'){
        return;
      }
      const id = sessionStorage.getItem("courseId");
      const locale = this.$i18n.locale;
      if (id && !this.$store.state.isPreview) {
        UserCourseAPI.addUserCourse(id)
          .then(res=> {
            const languages = res.course.languages;
            if(!languages.includes(locale) && languages.length > 0){
              localStorage.setItem('lan',languages[0]);
              localStorage.setItem('sound',this.sound.filter(ele => languages[0].indexOf(ele.id) != -1)[0].code);
              location.reload();
            }
            const langs = this.langs;
            const langXs = this.langXs;
            const sound = this.sound;
            this.langs = langs.filter(ele => languages.includes(ele.code));
            this.langXs = langXs.filter(ele => languages.includes(ele.code));
            this.sound = sound.filter(ele => languages.includes(ele.id));
          })
      }
    }
  },
  created () {
    this.soundLocale = localStorage.getItem("sound") || "TW";
    this.setLang();
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dropdown {
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  margin: 5px;
}
/deep/.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background: rgba(22, 182, 149, 1);
  color: #fff;
}
.sound_icon {
  width: 15px;
  margin-left: 5px;
  position: relative;
  top: 2px;
}
.lan_menu_hover {
  background: rgba(22, 182, 149, 1);
  color: #fff;
}
</style>